/** @format */

import React, { useRef, useEffect } from "react";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";

import { ExcelPrint } from "../../../../components/functions/Print";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { monthDays, monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { formatTableValue } from "../asosiymanbalar/formatTableValue";

function Table({ month, lmonth, setLmonth, data, selectedRowKeys, setSelectedRowKeys, loading, periodTabs }) {
  const conponentPDF = useRef();

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  useEffect(() => {
    if (loading) return;

    const todayCol = document.getElementById("today-column");
    if (todayCol) {
      todayCol.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [month, loading]);

  return (
    <div className='table-box'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          {periodTabs}
        </div>

        <ul className='table-top-right'>
          <li>
            <input
              type='month'
              className='form-control form-control-sm'
              value={lmonth}
              onChange={(e) => setLmonth(e.target.value)}
            />
          </li>

          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Asosiy nuqtalar", month, "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      {loading ? (
        <LoadingCard heightSize='80vh' loading={loading} />
      ) : (
        <div id='content'>
          <div
            id='tableFlexible'
            style={{ height: selectedRowKeys === "" ? "80vh" : "37vh" }}>
            <div ref={conponentPDF} style={{ width: "100%" }}>
              <table
                data-cols-width=', 7, 42, 15'
                id='tblData'
                className='table table-bordered table-style fixedHeader'>
                <thead className=''>
                  <tr data-height='25'>
                    <th
                      data-fill-color='ff6347'
                      data-f-bold='true'
                      data-b-a-s='thin'
                      data-a-v='middle'
                      data-a-h='center'
                      rowSpan={2}
                      className='sticky st1'>
                      o
                    </th>

                    <th
                      data-fill-color='ff6347'
                      data-f-bold='true'
                      data-b-a-s='thin'
                      data-a-v='middle'
                      data-a-h='center'
                      rowSpan={2}
                      className='sticky'
                      style={{ left: "31px" }}>
                      T/R
                    </th>

                    <th
                      data-fill-color='ff6347'
                      data-f-bold='true'
                      data-b-a-s='thin'
                      data-a-v='middle'
                      data-a-h='center'
                      rowSpan={2}
                      className='sticky'
                      style={{ left: "72px" }}>
                      Suv olish nuqtalari
                    </th>

                    <th
                      data-fill-color='ff6347'
                      data-f-bold='true'
                      data-b-a-s='thin'
                      data-a-v='middle'
                      data-a-h='center'
                      rowSpan={2}
                      className='sticky'
                      style={{ left: "330px" }}>
                      O'lchov birligi
                    </th>

                    <th
                      data-fill-color='ff6347'
                      data-f-bold='true'
                      data-b-a-s='thin'
                      data-a-v='middle'
                      data-a-h='center'
                      colSpan={monthDays(month)}>
                      {monthName(month)}
                    </th>
                  </tr>

                  <tr data-height='25'>
                    {Array(monthDays(month))
                      .fill()
                      .map((_, i) => {
                        return (
                          <th
                            data-fill-color='ff6347'
                            data-f-bold='true'
                            data-b-a-s='thin'
                            data-a-v='middle'
                            data-a-h='center'
                            data-t='n'
                            key={i}>
                            {i < 9 ? "0" + (i + 1) : i + 1}
                          </th>
                        );
                      })}
                  </tr>
                </thead>

                {data.length > 0
                  ? data.map((d, index) => {
                      if (!d || Object.keys(d).length === 0) return null;
                      return (
                        <tbody key={index}>
                          {index === 3 ? (
                            <tr data-height='20'>
                              <th></th>
                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Surxondaryo va Qashqadaryo
                              </th>
                            </tr>
                          ) : null}

                          {index === 27 ? (
                            <tr data-height='20'>
                              <th></th>
                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Buxoro va Navoiy
                              </th>
                            </tr>
                          ) : null}

                          {index === 45 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                QQR va Xorazm
                              </th>
                            </tr>
                          ) : null}

                          {index === 60 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Samarqand
                              </th>
                            </tr>
                          ) : null}

                          {index === 80 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Navoiy (Zarafshondan)
                              </th>
                            </tr>
                          ) : null}

                          {index === 83 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Namangan, Andijon, Farg'ona
                              </th>
                            </tr>
                          ) : null}

                          {index === 116 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Toshkent
                              </th>
                            </tr>
                          ) : null}

                          {index === 138 ? (
                            <tr data-height='20'>
                              <th></th>

                              <th
                                data-fill-color='42d1f5'
                                data-f-bold='true'
                                data-b-a-s='thin'
                                data-a-v='middle'
                                data-a-h='center'
                                className='fw-bold text-center'
                                colSpan={monthDays(month) + 4}>
                                Sirdaryo-Jizzax
                              </th>
                            </tr>
                          ) : null}

                          <tr className={"tr tr" + index}>
                            <td className='sticky st1'>
                              <input type='checkbox' />
                            </td>

                            <td
                              onClick={() => chiz(index)}
                              data-f-bold='true'
                              data-b-a-s='thin'
                              data-a-v='middle'
                              data-a-h='center'
                              data-t='n'
                              className='sticky'
                              style={{ left: "31px" }}>
                              {index + 1}
                            </td>

                            <td
                              onClick={() => chiz(index)}
                              data-f-bold='true'
                              data-b-a-s='thin'
                              data-a-v='middle'
                              className={
                                d.lat !== "" && d.lan !== ""
                                  ? "text-start sticky fix-with haslocation"
                                  : "text-start sticky fix-with"
                              }
                              style={{ left: "72px" }}>
                              {d.manba_nomi}
                            </td>

                            <td
                              onClick={() => chiz(index)}
                              data-f-bold='true'
                              data-b-a-s='thin'
                              data-a-v='middle'
                              data-a-h='center'
                              className='sticky'
                              style={{ left: "330px" }}>
                              {d.birligi}
                            </td>

                            {Array(monthDays(month))
                              .fill()
                              .map((_, i) => {
                                const day = i + 1;
                                const getValue = d["kun" + day];
                                const displayValue = formatTableValue(getValue);
                                const isToday = day === new Date().getDate();

                                return (
                                  <td
                                    onClick={() => chiz(index)}
                                    id={isToday ? "today-column" : undefined}
                                    data-b-a-s='thin'
                                    data-a-v='middle'
                                    data-a-h='center'
                                    data-t='n'
                                    style={{
                                      width: "60px",
                                      minWidth: "60px",
                                    }}
                                    key={i}>
                                    {displayValue}
                                  </td>
                                );
                              })}
                          </tr>
                        </tbody>
                      );
                    })
                  : null}
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Table;
